var cld;

function initializeCloudinaryPlayers() {
  window.players.forEach((player) => {
    if (player && player.widgetOptions) {
      var pCnf = JSON.parse(player.widgetOptions);
      var p = cld.videoPlayer(player.id, pCnf.playerConfig);
      p.source(player.public_id, pCnf.sourceConfig);
      p.on('error', function(e) {
        const error = e.Player.videojs.error();
        if (error && error.code === 10) {
          p.videojs.error(null);
          p.videojs.error({ code: null, message: 'Generating the video, please wait.' });
        }
      });

      p.on('fullscreenchange', (event) => {
        if (!p.isMaximized()) {
          p.pause();
        }
      });

      $(document).on('click', '.cta-video-fullscreen', function() {
        p.maximize();
        p.play();
      });
    }
  });
}

$(document).ready(function() {
  /**
   * Page Designer does not become active until document.ready. Because if this
   * it waits until streaming videos fully load. We need to delay initializing
   * Cloudinary video player a little bit.
   */

  if (!document.cloudinaryInit) {
    document.cloudinaryInit = true;
    setTimeout(function() {
      let conf = {
        cloud_name: window.cloudName
      };
      if (window.cname) {
        conf.secure_distribution = window.cname;
        conf.private_cdn = true;
      }
      cld = window.cldPDVideoPlayer
        ? window.cldPDVideoPlayer.Cloudinary.new(conf)
        : cloudinary.Cloudinary.new(conf);
      initializeCloudinaryPlayers();
    }, 100);
  }
});
